import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import getPictureUrl from 'utils/image/getPictureUrl';
import Box from 'components/Box';
import PageSection from 'components/PageSection';
import TopicCard from 'components/TopicCard';
import { RECOMMENDED_TOPIC_THUMBNAIL_SIZE } from 'screens/ThumbnailPreview';
import Wrapper from '../common/Wrapper';
export function TopicThumbnailPreview(props) {
  var _props$data = props.data,
    thumbnailId = _props$data.thumbnailId,
    name = _props$data.name,
    onClose = props.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Wrapper, {
    id: "preview-topic-modal",
    title: t('thumbnail_preview_item_image_preview', {
      itemName: t('content_type_topic')
    }),
    aspectRatio: "8:5",
    recommendedSize: RECOMMENDED_TOPIC_THUMBNAIL_SIZE,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(PageSection, null, /*#__PURE__*/React.createElement(Box, {
    width: 165
  }, /*#__PURE__*/React.createElement(TopicCard, {
    icon: "topic",
    imageSrc: getPictureUrl({
      id: thumbnailId,
      dimensions: 'w_165,h_103'
    })
  }, name))));
}
export default TopicThumbnailPreview;